<template>
  <CustomerFormBase
    v-model="localCustomer"
    :validation-schema="basicCustomerFormSchema"
    :address="address"
    :address2="address2"
    :addressError="addressError"
    :showBirthInfo="true"
    :showAddress="true"
    @update:address2="$emit('update:address2', $event)"
    @newAddress="$emit('newAddress', $event)"
    @continue="$emit('continue')"
  />
</template>

<script>
import * as yup from "yup";
import { phoneRegex } from "@estaly/ui";
import CustomerFormBase from "@/components/pos/subscription/formwithsteps/CustomerFormBase.vue";

const today = new Date();
const eighteenYearsAgo = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());

const basicCustomerFormSchema = yup.object({
  customer: yup.object({
    email: yup.string().required("L'email est requis.").email("L'email doit être valide"),
    phone: yup
      .string()
      .required("Le numéro de téléphone est requis.")
      .matches(phoneRegex, "Le numéro de téléphone n'est pas valide."),
    firstName: yup
      .string()
      .required("Le prénom du client est requis.")
      .min(2, "Le prénom doit comporter au moins 2 caractères."),
    lastName: yup
      .string()
      .required("Le nom du client est requis.")
      .min(2, "Le nom doit comporter au moins 2 caractères."),
    birthDate: yup
      .date()
      .required("La date de naissance est requise.")
      .typeError("La date de naissance est invalide.")
      .max(eighteenYearsAgo, "L'utilisateur doit avoir 18 ans ou plus."),
    birthCity: yup
      .string()
      .required("La ville de naissance est requise.")
      .min(2, "La ville de naissance doit comporter au moins 2 caractères."),
    birthCountry: yup
      .string()
      .required("Le pays de naissance est requis.")
      .min(2, "Le pays de naissance doit comporter au moins 2 caractères."),
    nationality: yup.string().required("La nationalité est requise."),
    buyerRole: yup
      .string()
      .required("La profession est requise.")
      .min(4, "La profession doit comporter au moins 4 caractères."),
  }),
});

export default {
  components: {
    CustomerFormBase,
  },
  props: {
    modelValue: Object,
    address: {
      type: Object,
      default: () => ({}),
    },
    address2: String,
    addressError: Boolean,
  },
  emits: ["update:modelValue", "update:address2", "newAddress", "continue"],
  data() {
    return { basicCustomerFormSchema };
  },
  computed: {
    localCustomer: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
};
</script>
